<template>
  <span v-if="decodedValue">
    <!--Date-->
    <template v-if="typeFormat === 'Date'">
      {{ decodedValue | dateString('MM/DD/YYYY') }}
    </template>
    <!--Textarea-->
    <template v-else-if="typeFormat === 'Textarea'">
      <html-block :html="decodedValue | stripTags | nl2br" />
    </template>
    <!--Array of Strings-->
    <template v-else-if="Array.isArray(decodedValue)">
      <ul>
        <li v-for="(val, $index) in decodedValue" :key="$index">
          {{ val }}
        </li>
      </ul>
    </template>
    <!--All Others-->
    <template v-else>
      {{ decodedValue }}
    </template>
  </span>
</template>

<script>
import { formsMixin } from '../../mixins/forms/formsMixin'
import HtmlBlock from './HtmlBlock'

export default {
  components: {
    HtmlBlock
  },
  mixins: [
    formsMixin
  ],
  props: {
    value: String,
    customField: Object
  },
  computed: {
    decodedValue () {
      return this.value && typeof this.value === 'string' ? JSON.parse(this.value) : ''
    },
    typeFormat () {
      return this.customField ? this.customField.format : null
    }
  }
}
</script>
